import React from 'react';

export default function IconSupport() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={26}
      height={26}
      fill="none"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M6.5 13V9.75c0-3.591 2.909-6.5 6.5-6.5s6.5 2.909 6.5 6.5v6.5c0 3.591-2.909 6.5-6.5 6.5M6.5 12.188a1.625 1.625 0 1 0-3.25 0v3.25a1.625 1.625 0 1 0 3.25 0v-3.25ZM19.5 15.438a1.625 1.625 0 1 0 3.25 0v-3.25a1.625 1.625 0 1 0-3.25 0v3.25Z"
      />
    </svg>
  );
}
